import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import { useRootAppStore } from "@hooks";

function ThemeToggleButton() {
	const { t } = useTranslation();

	const { isLightTheme, toggleTheme } = useRootAppStore().themeStore;

	const toggleThemeStatus = () => {
		toggleTheme();
	};

	return (
		<div className="toggle toggle--theme">
			<input
				id="theme"
				type="checkbox"
				className="toggle__input toggle--theme__input"
				onChange={toggleThemeStatus}
				checked={!isLightTheme}
			/>
			<label
				htmlFor="theme"
				className="toggle__handle toggle--theme__handle"
				data-label-light={t<string>("HEADER.THEME_LABEL_LIGHT")}
				data-label-dark={t<string>("HEADER.THEME_LABEL_DARK")}
			/>
		</div>
	);
}

export default observer(ThemeToggleButton);
